<template>
  <form @submit.prevent="submit">
    <label>
      {{ i18n.t('/change-order/bulk/upload-future-prices') }}
    </label>
    <br />
    <div class="input-panel">
      <app-button
        data-qa="bulk-upload-future-prices-button"
        :disabled="isLoading"
        @click="selectExcelFile"
      >
        <span v-if="!isLoading">
          {{ i18n.t('/change-order/bulk/upload') }}
        </span>
        <loader v-else />
      </app-button>

      <app-button data-qa="bulk-template-download-future-prices-button" @click="downloadTemplate">
        <span>
          {{ i18n.t('/change-order/bulk/template') }}
        </span>
      </app-button>
    </div>
    <error-modal
      v-show="validationMessages.length > 0"
      :title="i18n.t('/change-order/bulk/error-load')"
      :errors="validationMessages"
    ></error-modal>
  </form>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import { computed, ref } from 'vue'
import { useFileDialog } from '@vueuse/core'
import BulkFuturePricesService from '@/services/bulkFuturePricesService'
import ErrorModal from '@/components/generic/presentational/atoms/errorModal/ErrorModal.vue'

export default {
  components: {
    ErrorModal,
    Loader,
    AppButton,
  },
  setup(props, { emit }) {
    const isLoading = ref(false)
    const futurePricesResult = ref(null)

    const { open, reset, onChange } = useFileDialog({
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      multiple: false,
      directory: false,
    })

    function selectExcelFile() {
      resetErrors()
      open()
    }

    function resetErrors() {
      futurePricesResult.value = null
    }

    const validationMessages = computed(() => {
      return futurePricesResult.value?.ValidationMessages || []
    })

    onChange(async (files) => {
      if (files && files.length > 0) {
        isLoading.value = true
        let selectedFile = files[0]
        console.log('File selected:', selectedFile.name + ' size: ' + selectedFile.size)

        try {
          futurePricesResult.value = await BulkFuturePricesService.upload(selectedFile)

          if (futurePricesResult.value) {
            reset()
            isLoading.value = false
            emit('file-uploaded', futurePricesResult.value)
          }
        } catch (error) {
          console.error('Error uploading file:', error)

          // Extract the error messages for error response (400/404/500)
          if (error.response && error.response.data && error.response.data.Messages) {
            futurePricesResult.value = { ValidationMessages: error.response.data.Messages }
          } else {
            futurePricesResult.value = { ValidationMessages: ['An unknown error occurred.'] }
          }

          isLoading.value = false
        }
      } else {
        isLoading.value = false
      }
    })

    return {
      isLoading,
      validationMessages,
      selectExcelFile,
    }
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  methods: {
    downloadTemplate() {
      const link = document.createElement('a')
      link.href =
        'https://docs.google.com/spreadsheets/d/1XpT3AqZC93WlSqO21axvKxXnyj4GyJVBHJd6bJxPwJg/edit?usp=sharing'
      link.setAttribute('target', '_blank')
      link.setAttribute('download', 'template.xlsx')
      link.click()
    },
  },
}
</script>

<style lang="scss" scoped></style>
